import styled from '@emotion/styled';

export const Delimeter = styled.div((props) => ({
  width: '100%',
  height: 1,
  borderBottom: `0.5px solid ${props.theme.colors.container.tertiary}`,
  margin: '8px 0',
}));
